import { api } from "@services/baseURL";

export const SaveServico = async (data) => {
  try {
    const response = await api.post('TipoServico', data);
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar servico:', error);
    throw error;
  }
};

export const UpdateServico = async (id, data) => {
  try {
    const response = await api.patch(`TipoServico/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar serviço:', error);
    throw error;
  }
};

export const DeleteServico = async (id) => {
  try {
    await api.delete(`TipoServico/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar serviço:', error);
    throw error;
  }
};

export const GetAllServicos = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('TipoServico', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos serviços:', error);
    throw error;
  }
};

export const GetByIdServico = async (id) => {
  try {
    const response = await api.get('TipoServico', { "id:": id });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar serviço:', error);
    throw error;
  }
};

export const GetAllYears = async () => {
  try {
    const response = await api.get('TipoServico/allyears');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar anos dos serviços:', error);
    throw error;
  }
};

export const GetAllByYear = async (year) => {
  try {
    const response = await api.get(`TipoServico/year/${year}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar anos dos serviços:', error);
    throw error;
  }
};

export default {
  SaveServico,
  UpdateServico,
  DeleteServico,
  GetByIdServico,
  GetAllServicos,
  GetAllYears,
};